<div class="header-container">
  <span class="material-symbols-outlined icon icon-titre">{{ arianeIcon }}</span>
  <mat-radio-group class="ml-50 mb-10" aria-label="Choisir une option" [(ngModel)]="isRecrutementActive" (change)="onRadioChange($event)">
    <mat-radio-button class="custom-radio-button" [value]="true" [ngClass]="{ active: isRecrutementActive }"
      ><span style="cursor: pointer; width: 100%"
      >VALIDATION RECRUTEMENT ({{ countRecrutementEnAttente !== undefined ? countRecrutementEnAttente : 0 }})</span
      >
    </mat-radio-button>
    <mat-radio-button [value]="false" class="custom-radio-button" [ngClass]="{ active: !isRecrutementActive }">
      <span style="cursor: pointer; width: 100%"
        >VALIDATION RENOUVELLEMENT ({{ countRenouvellementEnAttente !== undefined ? countRenouvellementEnAttente : 0 }})</span
        >
      </mat-radio-button>
    </mat-radio-group>
  </div>

  <mat-divider class="my-3"></mat-divider>
  <div class="div-conteneur">
    <!-- Validation recrutement -->
    <div [hidden]="!isRecrutementActive">
      <mat-tab-group preserveContent="true">
        <!-- En attente tab -->
        <mat-tab label="EN ATTENTE DE VALIDATION ({{ countRecrutementEnAttente || 0 }})">
          <ng-template matTabContent>
            <div class="action-buttons mb-2">
              <button class="bt-table-defaut mr-5" mat-stroked-button (click)="exporterEnMasseRecrutement()">
                <mat-icon>download</mat-icon> Exporter
              </button>
              <button
                mat-stroked-button
                class="bt-table-defaut mr-5"
                (click)="togglePanel('Recrutement')"
                [style]="panelOpenStateRecrutement ? 'border: 2px solid #405d9c;' : ''"
                >
                @if (!panelOpenStateRecrutement) {
                  <mat-icon>filter_alt</mat-icon>
                }
                @if (
                  !panelOpenStateRecrutement &&
                  ((filterSubjectRecrutement | async)?.emetteur ||
                  (filterSubjectRecrutement | async)?.direction ||
                  (filterSubjectRecrutement | async)?.serviceFonctionnel ||
                  (filterSubjectRecrutement | async)?.numeroPoste ||
                  (filterSubjectRecrutement | async)?.dateCreationStart ||
                  (filterSubjectRecrutement | async)?.dateCreationEnd ||
                  (filterSubjectRecrutement | async)?.statut ||
                  (filterSubjectRecrutement | async)?.typeRecrutement)
                  ) {
                  <mat-icon
                    class="icon-filtre-check"
                    >check_circle</mat-icon
                    >
                  }

                  @if (panelOpenStateRecrutement) {
                    <mat-icon>filter_alt</mat-icon>
                  }
                  @if (!panelOpenStateRecrutement) {
                    <span> {{ filtrer_libelleRecrutement$ | async }}</span>
                  }
                  @if (panelOpenStateRecrutement) {
                    <span> Liste des filtres </span>
                  }
                  @if (!panelOpenStateRecrutement) {
                    <mat-icon iconPositionEnd>keyboard_arrow_down</mat-icon>
                  }
                  @if (panelOpenStateRecrutement) {
                    <mat-icon iconPositionEnd>keyboard_arrow_up</mat-icon>
                  }
                </button>

                <button class="bt-table-defaut mr-5" mat-stroked-button (click)="reviserDemandesEnMasse()">
                  <mat-icon>rules</mat-icon> Réviser en masse
                </button>
              </div>
              <mat-expansion-panel class="panel-filtre" [expanded]="panelOpenStateRecrutement" style="width: 100%">
                <app-filter-controls
                  (filterApplied)="onFilterAppliedRecrutementGlobal($event, 'enAttente')"
                  [showDirection]="true"
                  [showService]="true"
                  [showNumeroPoste]="true"
                  [showAgentRenouvele]="false"
                  [showTypeRecrutement]="true"
                ></app-filter-controls>
              </mat-expansion-panel>

              <app-data-table-optimized
                #enAttenteTable
                [getData]="getDemandesRecrutementEnAttente"
                [displayedColumns]="demandesDisplayedColumns"
                [externalFilter$]="filterSubjectRecrutement"
                [cellStyleCss]="demandesCellStyleCss"
                [headerStyleCss]="demandesHeaderStyleCss"
                [selectable]="true"
                [validable]="true"
                [refusable]="true"
                [advicable]="true"
                [hasView]="true"
                (validateItem)="validerDemande($event)"
                (refuseItem)="refuserDemande($event)"
                (showDetail)="showDetails($event)"
                (getAdviceEvent)="avisDemande($event)"
                >
              </app-data-table-optimized>
            </ng-template>
          </mat-tab>

          <!-- Validées tab -->
          <mat-tab label="VALIDÉES ({{ countRecrutementValidees || 0 }})">
            <ng-template matTabContent>
              <div class="action-buttons mb-2">
                <button
                  mat-stroked-button
                  class="bt-table-defaut mr-5"
                  (click)="togglePanel('RecrutementValidees')"
                  [style]="panelOpenStateRecrutementValidees ? 'border: 2px solid #405d9c;' : ''"
                  >
                  @if (!panelOpenStateRecrutementValidees) {
                    <mat-icon>filter_alt</mat-icon>
                  }
                  @if (
                    !panelOpenStateRecrutementValidees &&
                    ((filterSubjectRecrutementValidees | async)?.emetteur ||
                    (filterSubjectRecrutementValidees | async)?.direction ||
                    (filterSubjectRecrutementValidees | async)?.serviceFonctionnel ||
                    (filterSubjectRecrutementValidees | async)?.numeroPoste ||
                    (filterSubjectRecrutementValidees | async)?.dateCreationStart ||
                    (filterSubjectRecrutementValidees | async)?.dateCreationEnd ||
                    (filterSubjectRecrutementValidees | async)?.statut ||
                    (filterSubjectRecrutementValidees | async)?.typeRecrutement)
                    ) {
                    <mat-icon
                      class="icon-filtre-check"
                      >check_circle</mat-icon
                      >
                    }

                    @if (panelOpenStateRecrutementValidees) {
                      <mat-icon>filter_alt</mat-icon>
                    }
                    @if (!panelOpenStateRecrutementValidees) {
                      <span> {{ filtrer_libelleRecrutementValidees$ | async }}</span>
                    }
                    @if (panelOpenStateRecrutementValidees) {
                      <span> Liste des filtres </span>
                    }
                    @if (!panelOpenStateRecrutementValidees) {
                      <mat-icon iconPositionEnd>keyboard_arrow_down</mat-icon>
                    }
                    @if (panelOpenStateRecrutementValidees) {
                      <mat-icon iconPositionEnd>keyboard_arrow_up</mat-icon>
                    }
                  </button>
                </div>
                <mat-expansion-panel class="panel-filtre" [expanded]="panelOpenStateRecrutementValidees" style="width: 100%">
                  <app-filter-controls
                    (filterApplied)="onFilterAppliedRecrutementGlobal($event, 'validees')"
                    [showDirection]="true"
                    [showService]="true"
                    [showNumeroPoste]="true"
                    [showAgentRenouvele]="false"
                    [showTypeRecrutement]="true"
                  ></app-filter-controls>
                </mat-expansion-panel>

                <app-data-table-optimized
                  #validees
                  [getData]="getDemandesRecrutementValidees"
                  [displayedColumns]="demandesDisplayedColumnsNoSelect"
                  [externalFilter$]="filterSubjectRecrutementValidees"
                  [cellStyleCss]="demandesCellStyleCss"
                  [headerStyleCss]="demandesHeaderStyleCss"
                  [selectable]="false"
                  [hasView]="true"
                  (showDetail)="showDetails($event)"
                  >
                </app-data-table-optimized>
              </ng-template>
            </mat-tab>

            <!-- Refusées tab -->
            <mat-tab label="REFUSÉES ({{ countRecrutementRefusees || 0 }})">
              <ng-template matTabContent>
                <div class="action-buttons mb-2">
                  <button
                    mat-stroked-button
                    class="bt-table-defaut mr-5"
                    (click)="togglePanel('RecrutementRefusees')"
                    [style]="panelOpenStateRecrutementRefusees ? 'border: 2px solid #405d9c;' : ''"
                    >
                    @if (!panelOpenStateRecrutementRefusees) {
                      <mat-icon>filter_alt</mat-icon>
                    }
                    @if (
                      !panelOpenStateRecrutementRefusees &&
                      ((filterSubjectRecrutementRefusees | async)?.emetteur ||
                      (filterSubjectRecrutementRefusees | async)?.direction ||
                      (filterSubjectRecrutementRefusees | async)?.serviceFonctionnel ||
                      (filterSubjectRecrutementRefusees | async)?.numeroPoste ||
                      (filterSubjectRecrutementRefusees | async)?.dateCreationStart ||
                      (filterSubjectRecrutementRefusees | async)?.dateCreationEnd ||
                      (filterSubjectRecrutementRefusees | async)?.statut ||
                      (filterSubjectRecrutementRefusees | async)?.typeRecrutement)
                      ) {
                      <mat-icon
                        class="icon-filtre-check"
                        >check_circle</mat-icon
                        >
                      }

                      @if (panelOpenStateRecrutementRefusees) {
                        <mat-icon>filter_alt</mat-icon>
                      }
                      @if (!panelOpenStateRecrutementRefusees) {
                        <span> {{ filtrer_libelleRecrutementRefusees$ | async }}</span>
                      }
                      @if (panelOpenStateRecrutementRefusees) {
                        <span> Liste des filtres </span>
                      }
                      @if (!panelOpenStateRecrutementRefusees) {
                        <mat-icon iconPositionEnd>keyboard_arrow_down</mat-icon>
                      }
                      @if (panelOpenStateRecrutementRefusees) {
                        <mat-icon iconPositionEnd>keyboard_arrow_up</mat-icon>
                      }
                    </button>
                  </div>
                  <mat-expansion-panel class="panel-filtre" [expanded]="panelOpenStateRecrutementRefusees" style="width: 100%">
                    <app-filter-controls
                      (filterApplied)="onFilterAppliedRecrutementGlobal($event, 'refusees')"
                      [showDirection]="true"
                      [showService]="true"
                      [showNumeroPoste]="true"
                      [showAgentRenouvele]="false"
                      [showTypeRecrutement]="true"
                    ></app-filter-controls>
                  </mat-expansion-panel>

                  <app-data-table-optimized
                    #refusees
                    [getData]="getDemandesRecrutementRefusees"
                    [displayedColumns]="demandesDisplayedColumnsNoSelect"
                    [externalFilter$]="filterSubjectRecrutementRefusees"
                    [cellStyleCss]="demandesCellStyleCss"
                    [headerStyleCss]="demandesHeaderStyleCss"
                    [selectable]="false"
                    [hasView]="true"
                    [recallRefusable]="true"
                    (showDetail)="showDetails($event)"
                    (recallRefuseItem)="annulerRefus($event)"
                    >
                  </app-data-table-optimized>
                </ng-template>
              </mat-tab>

              <!-- Voir tout tab -->
              <mat-tab label="VOIR TOUT ({{ countRecrutementTotal || 0 }})">
                <ng-template matTabContent>
                  <div class="action-buttons mb-2">
                    <button
                      mat-stroked-button
                      class="bt-table-defaut mr-5"
                      (click)="togglePanel('RecrutementVoirTout')"
                      [style]="panelOpenStateRecrutementVoirTout ? 'border: 2px solid #405d9c;' : ''"
                      >
                      @if (!panelOpenStateRecrutementVoirTout) {
                        <mat-icon>filter_alt</mat-icon>
                      }
                      @if (
                        !panelOpenStateRecrutementVoirTout &&
                        ((filterSubjectRecrutementVoirTout | async)?.emetteur ||
                        (filterSubjectRecrutementVoirTout | async)?.direction ||
                        (filterSubjectRecrutementVoirTout | async)?.serviceFonctionnel ||
                        (filterSubjectRecrutementVoirTout | async)?.numeroPoste ||
                        (filterSubjectRecrutementVoirTout | async)?.dateCreationStart ||
                        (filterSubjectRecrutementVoirTout | async)?.dateCreationEnd ||
                        (filterSubjectRecrutementVoirTout | async)?.statut ||
                        (filterSubjectRecrutementVoirTout | async)?.typeRecrutement)
                        ) {
                        <mat-icon
                          class="icon-filtre-check"
                          >check_circle</mat-icon
                          >
                        }

                        @if (panelOpenStateRecrutementVoirTout) {
                          <mat-icon>filter_alt</mat-icon>
                        }
                        @if (!panelOpenStateRecrutementVoirTout) {
                          <span> {{ filtrer_libelleRecrutementVoirTout$ | async }}</span>
                        }
                        @if (panelOpenStateRecrutementVoirTout) {
                          <span> Liste des filtres </span>
                        }
                        @if (!panelOpenStateRecrutementVoirTout) {
                          <mat-icon iconPositionEnd>keyboard_arrow_down</mat-icon>
                        }
                        @if (panelOpenStateRecrutementVoirTout) {
                          <mat-icon iconPositionEnd>keyboard_arrow_up</mat-icon>
                        }
                      </button>
                    </div>
                    <mat-expansion-panel class="panel-filtre" [expanded]="panelOpenStateRecrutementVoirTout" style="width: 100%">
                      <app-filter-controls
                        (filterApplied)="onFilterAppliedRecrutementGlobal($event, 'voirTout')"
                        [showDirection]="true"
                        [showService]="true"
                        [showNumeroPoste]="true"
                        [showAgentRenouvele]="false"
                        [showTypeRecrutement]="true"
                      ></app-filter-controls>
                    </mat-expansion-panel>
                    <app-data-table-optimized
                      #voirTout
                      [getData]="getDemandesRecrutementTotal"
                      [displayedColumns]="demandesDisplayedColumnsNoSelect"
                      [externalFilter$]="filterSubjectRecrutementVoirTout"
                      [cellStyleCss]="demandesCellStyleCss"
                      [headerStyleCss]="demandesHeaderStyleCss"
                      [hasView]="true"
                      (showDetail)="showDetails($event)"
                      >
                    </app-data-table-optimized>
                  </ng-template>
                </mat-tab>
              </mat-tab-group>
            </div>
            <!-- Validation renouvellement -->
            <div [hidden]="isRecrutementActive">
              <mat-tab-group preserveContent="true" (selectedTabChange)="onTabChange($event)">
                <!-- En attente tab -->
                <mat-tab label="EN ATTENTE DE VALIDATION ({{ countRenouvellementEnAttente || 0 }})">
                  <ng-template matTabContent>
                    <div class="action-buttons mb-2">
                      <button class="bt-table-defaut mr-5" mat-stroked-button (click)="exporterEnMasseRenouvellement()">
                        <mat-icon>download</mat-icon> Exporter
                      </button>
                      <button
                        mat-stroked-button
                        class="bt-table-defaut mr-5"
                        (click)="togglePanel('Renouvellement')"
                        [style]="panelOpenStateRenouvellement ? 'border: 2px solid #405d9c;' : ''"
                        >
                        @if (!panelOpenStateRenouvellement) {
                          <mat-icon>filter_alt</mat-icon>
                        }
                        @if (
                          !panelOpenStateRenouvellement &&
                          ((filterSubjectRenouvellement | async)?.emetteur ||
                          (filterSubjectRenouvellement | async)?.direction ||
                          (filterSubjectRenouvellement | async)?.serviceFonctionnel ||
                          (filterSubjectRenouvellement | async)?.numeroPoste ||
                          ((filterSubjectRenouvellement | async)?.agentRenouveleId || (filterSubjectRenouvellement | async)?.agentRenouvele) ||
                          (filterSubjectRenouvellement | async)?.dateCreationStart ||
                          (filterSubjectRenouvellement | async)?.dateCreationEnd ||
                          (filterSubjectRenouvellement | async)?.statut ||
                          (filterSubjectRenouvellement | async)?.typeRenouvellement)
                          ) {
                          <mat-icon
                            class="icon-filtre-check"
                            >check_circle</mat-icon
                            >
                          }

                          @if (panelOpenStateRenouvellement) {
                            <mat-icon>filter_alt</mat-icon>
                          }
                          @if (!panelOpenStateRenouvellement) {
                            <span> {{ filtrer_libelleRenouvellement$ | async }}</span>
                          }
                          @if (panelOpenStateRenouvellement) {
                            <span> Liste des filtres </span>
                          }
                          @if (!panelOpenStateRenouvellement) {
                            <mat-icon iconPositionEnd>keyboard_arrow_down</mat-icon>
                          }
                          @if (panelOpenStateRenouvellement) {
                            <mat-icon iconPositionEnd>keyboard_arrow_up</mat-icon>
                          }
                        </button>
                        <button class="bt-table-defaut mr-5" mat-stroked-button (click)="reviserDemandesEnMasse()">
                          <mat-icon>rules</mat-icon> Réviser en masse
                        </button>
                      </div>
                      <mat-expansion-panel class="panel-filtre" [expanded]="panelOpenStateRenouvellement" style="width: 100%">
                        <app-filter-controls
                          (filterApplied)="onFilterAppliedRenouvellementGlobal($event, 'renouvellementEnAttente')"
                          [showDirection]="true"
                          [showService]="true"
                          [showNumeroPoste]="true"
                          [showAgentRenouvele]="true"
                          [showTypeRenouvellement]="true"
                        ></app-filter-controls>
                      </mat-expansion-panel>
                      <app-data-table-optimized
                        #activeTableRenouvellementEnAttente
                        [getData]="getDemandesRenouvellementEnAttente"
                        [displayedColumns]="demandesRenouvellementDisplayedColumns"
                        [externalFilter$]="filterSubjectRenouvellement"
                        [cellStyleCss]="demandesCellStyleCss"
                        [headerStyleCss]="demandesHeaderStyleCss"
                        [selectable]="true"
                        [validable]="true"
                        [refusable]="true"
                        [hasView]="true"
                        [advicable]="true"
                        (validateItem)="validerDemande($event)"
                        (refuseItem)="refuserDemande($event)"
                        (showDetail)="showDetails($event)"
                        (getAdviceEvent)="avisDemande($event)"
                        >
                      </app-data-table-optimized>
                    </ng-template>
                  </mat-tab>

                  <!-- Validées tab -->
                  <mat-tab label="VALIDÉES ({{ countRenouvellementValidees || 0 }})">
                    <ng-template matTabContent>
                      <div class="action-buttons mb-2">
                        <button
                          mat-stroked-button
                          class="bt-table-defaut mr-5"
                          (click)="togglePanel('RenouvellementValidees')"
                          [style]="panelOpenStateRenouvellementValidees ? 'border: 2px solid #405d9c;' : ''"
                          >
                          @if (!panelOpenStateRenouvellementValidees) {
                            <mat-icon>filter_alt</mat-icon>
                          }
                          @if (
                            !panelOpenStateRenouvellementValidees &&
                            ((filterSubjectRenouvellementValidees | async)?.emetteur ||
                            (filterSubjectRenouvellementValidees | async)?.direction ||
                            (filterSubjectRenouvellementValidees | async)?.serviceFonctionnel ||
                            (filterSubjectRenouvellementValidees | async)?.numeroPoste ||
                            ((filterSubjectRenouvellementValidees | async)?.agentRenouveleId || (filterSubjectRenouvellementValidees | async)?.agentRenouvele) ||
                            (filterSubjectRenouvellementValidees | async)?.dateCreationStart ||
                            (filterSubjectRenouvellementValidees | async)?.dateCreationEnd ||
                            (filterSubjectRenouvellementValidees | async)?.statut ||
                            (filterSubjectRenouvellementValidees | async)?.typeRenouvellement)
                            ) {
                            <mat-icon
                              class="icon-filtre-check"
                              >check_circle</mat-icon
                              >
                            }

                            @if (panelOpenStateRenouvellementValidees) {
                              <mat-icon>filter_alt</mat-icon>
                            }
                            @if (!panelOpenStateRenouvellementValidees) {
                              <span> {{ filtrer_libelleRenouvellementValidees$ | async }}</span>
                            }
                            @if (panelOpenStateRenouvellementValidees) {
                              <span> Liste des filtres </span>
                            }
                            @if (!panelOpenStateRenouvellementValidees) {
                              <mat-icon iconPositionEnd>keyboard_arrow_down</mat-icon>
                            }
                            @if (panelOpenStateRenouvellementValidees) {
                              <mat-icon iconPositionEnd>keyboard_arrow_up</mat-icon>
                            }
                          </button>
                        </div>
                        <mat-expansion-panel class="panel-filtre" [expanded]="panelOpenStateRenouvellementValidees" style="width: 100%">
                          <app-filter-controls
                            (filterApplied)="onFilterAppliedRenouvellementGlobal($event, 'renouvellementValidees')"
                            [showDirection]="true"
                            [showService]="true"
                            [showNumeroPoste]="true"
                            [showAgentRenouvele]="true"
                            [showTypeRenouvellement]="true"
                          ></app-filter-controls>
                        </mat-expansion-panel>

                        <app-data-table-optimized
                          #activeTableRenouvellementValidees
                          [getData]="getDemandesRenouvellementValidees"
                          [displayedColumns]="demandesRenouvellementDisplayedColumnsNoSelect"
                          [externalFilter$]="filterSubjectRenouvellementValidees"
                          [cellStyleCss]="demandesCellStyleCss"
                          [headerStyleCss]="demandesHeaderStyleCss"
                          [selectable]="false"
                          [hasView]="true"
                          (showDetail)="showDetails($event)"
                          >
                        </app-data-table-optimized>
                      </ng-template>
                    </mat-tab>

                    <!-- Refusées tab -->
                    <mat-tab label="REFUSÉES ({{ countRenouvellementRefusees || 0 }})">
                      <ng-template matTabContent>
                        <div class="action-buttons mb-2">
                          <button
                            mat-stroked-button
                            class="bt-table-defaut mr-5"
                            (click)="togglePanel('RenouvellementRefusees')"
                            [style]="panelOpenStateRenouvellementRefusees ? 'border: 2px solid #405d9c;' : ''"
                            >
                            @if (!panelOpenStateRenouvellementRefusees) {
                              <mat-icon>filter_alt</mat-icon>
                            }
                            @if (
                              !panelOpenStateRenouvellementRefusees &&
                              ((filterSubjectRenouvellementRefusees | async)?.emetteur ||
                              (filterSubjectRenouvellementRefusees | async)?.direction ||
                              (filterSubjectRenouvellementRefusees | async)?.serviceFonctionnel ||
                              (filterSubjectRenouvellementRefusees | async)?.numeroPoste ||
                              ((filterSubjectRenouvellementRefusees | async)?.agentRenouveleId || (filterSubjectRenouvellementRefusees | async)?.agentRenouvele) ||
                              (filterSubjectRenouvellementRefusees | async)?.dateCreationStart ||
                              (filterSubjectRenouvellementRefusees | async)?.dateCreationEnd ||
                              (filterSubjectRenouvellementRefusees | async)?.statut ||
                              (filterSubjectRenouvellementRefusees | async)?.typeRenouvellement)
                              ) {
                              <mat-icon
                                class="icon-filtre-check"
                                >check_circle</mat-icon
                                >
                              }

                              @if (panelOpenStateRenouvellementRefusees) {
                                <mat-icon>filter_alt</mat-icon>
                              }
                              @if (!panelOpenStateRenouvellementRefusees) {
                                <span> {{ filtrer_libelleRenouvellementRefusees$ | async }}</span>
                              }
                              @if (panelOpenStateRenouvellementRefusees) {
                                <span> Liste des filtres </span>
                              }
                              @if (!panelOpenStateRenouvellementRefusees) {
                                <mat-icon iconPositionEnd>keyboard_arrow_down</mat-icon>
                              }
                              @if (panelOpenStateRenouvellementRefusees) {
                                <mat-icon iconPositionEnd>keyboard_arrow_up</mat-icon>
                              }
                            </button>
                          </div>
                          <mat-expansion-panel class="panel-filtre" [expanded]="panelOpenStateRenouvellementRefusees" style="width: 100%">
                            <app-filter-controls
                              (filterApplied)="onFilterAppliedRenouvellementGlobal($event, 'renouvellementRefusees')"
                              [showDirection]="true"
                              [showService]="true"
                              [showNumeroPoste]="true"
                              [showAgentRenouvele]="true"
                              [showTypeRenouvellement]="true"
                            ></app-filter-controls>
                          </mat-expansion-panel>
                          <app-data-table-optimized
                            #activeTableRenouvellementRefusees
                            [getData]="getDemandesRenouvellementRefusees"
                            [displayedColumns]="demandesRenouvellementDisplayedColumnsNoSelect"
                            [externalFilter$]="filterSubjectRenouvellementRefusees"
                            [cellStyleCss]="demandesCellStyleCss"
                            [headerStyleCss]="demandesHeaderStyleCss"
                            [selectable]="false"
                            [hasView]="true"
                            [recallRefusable]="true"
                            (showDetail)="showDetails($event)"
                            (recallRefuseItem)="annulerRefus($event)"
                            >
                          </app-data-table-optimized>
                        </ng-template>
                      </mat-tab>

                      <!-- Voir tout tab -->
                      <mat-tab label="VOIR TOUT ({{ countRenouvellementTotal || 0 }})">
                        <ng-template matTabContent>
                          <div class="action-buttons mb-2">
                            <button
                              mat-stroked-button
                              class="bt-table-defaut mr-5"
                              (click)="togglePanel('RenouvellementVoirTout')"
                              [style]="panelOpenStateRenouvellementVoirTout ? 'border: 2px solid #405d9c;' : ''"
                              >
                              @if (!panelOpenStateRenouvellementVoirTout) {
                                <mat-icon>filter_alt</mat-icon>
                              }
                              @if (
                                !panelOpenStateRenouvellementVoirTout &&
                                ((filterSubjectRenouvellementVoirTout | async)?.emetteur ||
                                (filterSubjectRenouvellementVoirTout | async)?.direction ||
                                (filterSubjectRenouvellementVoirTout | async)?.serviceFonctionnel ||
                                (filterSubjectRenouvellementVoirTout | async)?.numeroPoste ||
                                ((filterSubjectRenouvellementVoirTout | async)?.agentRenouveleId || (filterSubjectRenouvellementVoirTout | async)?.agentRenouvele) ||
                                (filterSubjectRenouvellementVoirTout | async)?.dateCreationStart ||
                                (filterSubjectRenouvellementVoirTout | async)?.dateCreationEnd ||
                                (filterSubjectRenouvellementVoirTout | async)?.statut ||
                                (filterSubjectRenouvellementVoirTout | async)?.typeRenouvellement)
                                ) {
                                <mat-icon
                                  class="icon-filtre-check"
                                  >check_circle</mat-icon
                                  >
                                }

                                @if (panelOpenStateRenouvellementVoirTout) {
                                  <mat-icon>filter_alt</mat-icon>
                                }
                                @if (!panelOpenStateRenouvellementVoirTout) {
                                  <span> {{ filtrer_libelleRenouvellementVoirTout$ | async }}</span>
                                }
                                @if (panelOpenStateRenouvellementVoirTout) {
                                  <span> Liste des filtres </span>
                                }
                                @if (!panelOpenStateRenouvellementVoirTout) {
                                  <mat-icon iconPositionEnd>keyboard_arrow_down</mat-icon>
                                }
                                @if (panelOpenStateRenouvellementVoirTout) {
                                  <mat-icon iconPositionEnd>keyboard_arrow_up</mat-icon>
                                }
                              </button>
                            </div>
                            <mat-expansion-panel class="panel-filtre" [expanded]="panelOpenStateRenouvellementVoirTout" style="width: 100%">
                              <app-filter-controls
                                (filterApplied)="onFilterAppliedRenouvellementGlobal($event, 'renouvellementVoirTout')"
                                [showDirection]="true"
                                [showService]="true"
                                [showNumeroPoste]="true"
                                [showAgentRenouvele]="true"
                                [showTypeRenouvellement]="true"
                              ></app-filter-controls>
                            </mat-expansion-panel>
                            <app-data-table-optimized
                              #activeTableRenouvellementVoirTout
                              [getData]="getDemandesRenouvellementTotal"
                              [displayedColumns]="demandesRenouvellementDisplayedColumnsNoSelect"
                              [externalFilter$]="filterSubjectRenouvellementVoirTout"
                              [cellStyleCss]="demandesCellStyleCss"
                              [headerStyleCss]="demandesHeaderStyleCss"
                              [hasView]="true"
                              (showDetail)="showDetails($event)"
                              >
                            </app-data-table-optimized>
                          </ng-template>
                        </mat-tab>
                      </mat-tab-group>
                    </div>
                  </div>
